// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-list svg {\n  display: inline-block;\n  vertical-align: top;\n}\n.el-centered__main_aside .emd-list .emd-text {\n  display: inline-block;\n  vertical-align: top;\n  padding-left: 10px;\n  width: 85%;\n}\n._color_pagarme {\n  color: var(--brand--le--success-color--base);\n}\n", ""]);
// Exports
module.exports = exports;
